import { DTO_STATE, RECIPE_SIZE } from './dictionary';
// TODO: use a language version to change the format to that language
export const getDateTime = (date) => {
    let result = {
        date: '',
        time: '',
    };
    const dateTime = date === null || date === void 0 ? void 0 : date.toString().replace('T', ' ').slice(0, 16);
    if (dateTime) {
        let temp = dateTime === null || dateTime === void 0 ? void 0 : dateTime.split(' ');
        let date = temp[0].split('-');
        result.date = `${date[2]}.${date[1]}.${date[0]}`;
        result.time = temp[1];
    }
    return result;
};
export const getCalendarDate = (calendar) => {
    let temp = calendar === null || calendar === void 0 ? void 0 : calendar.split('/');
    return `${temp[2]}.${temp[1]}.${temp[0]}`;
};
// TODO: clean up if we don't need it
export const getRecipeSize = () => {
    // TODO: need to get user email for check who use application
    // only for Natali
    // const itemId = 11;
    // const qty = 3;
    // const parts = recipe.parts;
    // let contains = false;
    // parts?.some((p) => p.items?.some((i) => i.itemId === itemId));
    // recipe.parts?.forEach((p) =>
    //     p.items?.forEach((i) => {
    //         if (i.itemId === itemId) {
    //             if (i.proportions.some((p) => p.quantity === qty)) {
    //                 contains = true;
    //             }
    //         }
    //     })
    // );
    // if (recipe.flagSpecial) {
    //     return RECIPE_SIZE_SPECIAL;
    // }
    return RECIPE_SIZE;
};
/*export function compareObjects(obj1: any, obj2: any) {
    for (const key in obj1) {
        if (key === 'state' || key === 'productCost' || obj2 === undefined) continue;
        if (typeof obj1[key] === 'object' && obj1[key] !== null) {
            if (!compareObjects(obj1[key], obj2[key])) {
                return false;
            }
        } else if (obj1[key] !== obj2[key]) {
            return false;
        }
    }

    return true;
}*/
export function compareObjects(obj1, obj2) {
    if (obj1 === obj2)
        return true;
    if (typeof obj1 !== 'object' || typeof obj2 !== 'object' || obj1 === null || obj2 === null) {
        return obj1 === obj2;
    }
    if (Array.isArray(obj1) && Array.isArray(obj2)) {
        if (obj1.length !== obj2.length)
            return false;
        for (let i = 0; i < obj1.length; i++) {
            if (!compareObjects(obj1[i], obj2[i]))
                return false;
        }
        return true;
    }
    if (Array.isArray(obj1) !== Array.isArray(obj2))
        return false;
    const keys1 = Object.keys(obj1).filter((k) => k !== 'state' && k !== 'productCost');
    const keys2 = Object.keys(obj2).filter((k) => k !== 'state' && k !== 'productCost');
    if (keys1.length !== keys2.length)
        return false;
    for (const key of keys1) {
        if (!(key in obj2))
            return false;
        if (!compareObjects(obj1[key], obj2[key]))
            return false;
    }
    return true;
}
export function hasStateNewOrDeleted(objects) {
    return objects.some((item) => item.state === DTO_STATE.DTO_NEW || item.state === DTO_STATE.DTO_DELETED);
}
export function getCustomerName(customer) {
    const content = ['name', 'faceBook', 'instagram', 'email', 'phoneNumber']
        .map((key) => customer[key])
        .find((value, index) => (index === 0 ? value.length >= 3 : value.length >= 5));
    return content || '';
}
export const getCustomerFieldName = (validator, value) => {
    if (validator.isValidEmail(value, true))
        return 'email';
    if (validator.isValidPhoneNumber(value, true))
        return 'phoneNumber';
    if (validator.isValidInstagram(value, true))
        return 'instagram';
    if (validator.isValidFacebook(value, true))
        return 'faceBook';
    if (validator.isValidFirstName(value, true))
        return 'firstName';
    return '';
};
